<!--
作者：Loong
时间：2020/07/15
-->
<!-- userSet [ 用户管理 ] -->
<template>

    <div id='userSet'>
        
        <div class="userSet_search" style="margin-top: 20px ;">
			<el-form :inline="true" :model="select" class="demo-form-inline" @keyup.enter.native="getData">

				<el-form-item label="户号">
					<el-input v-model="select.account" placeholder="户号" style="width:170px;" :maxlength="12"></el-input>
				</el-form-item>
                
				<el-form-item label="业主类型">
					<el-select v-model="select.nature" placeholder="请选择" style="width: 140px;">
						<el-option v-for="item in natures" :key="item.num" :label="item.value" :value="item.num">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="业主姓名">
					<el-input v-model="select.owner_name" placeholder="业主姓名" style="width:170px;"></el-input>
				</el-form-item>

                <el-form-item label="业主手机">
					<el-input v-model="select.owner_phone" placeholder="业主手机" style="width:170px;"></el-input>
				</el-form-item>

                <el-form-item label="楼号">
					<el-input v-model="select.buildnum" placeholder="楼号" style="width:170px;"></el-input>
				</el-form-item>

                <el-form-item label="单元号">
					<el-input v-model="select.unitnum" placeholder="单元号" style="width:170px;"></el-input>
				</el-form-item>

                <el-form-item label="门牌号">
					<el-input v-model="select.doornum" placeholder="门牌号" style="width:170px;"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="getData">查询</el-button>
					<el-button type="primary" @click="resetting">重置</el-button>
					<el-button type="primary" @click="downCode()">导出</el-button>
				</el-form-item>

			</el-form>
		</div>

        <el-table :data="dataset" border style="width:1675px;text-align:center;margin-bottom: 10px;font-size:12px; " v-on:sort-change="getData">

			<el-table-column prop="account" label="户号" width="123" align="center" sortable="custom"></el-table-column>

			<el-table-column prop="owner_name" label="业主姓名" width="" align="center" sortable="custom"></el-table-column>

			<el-table-column prop="owner_phone" label="业主手机" width="" align="center" sortable="custom"></el-table-column>

            <el-table-column prop="nature" label="业主类型" width="" align="center" sortable="custom"></el-table-column>

            <el-table-column prop="community_name" label="小区名" width="" align="center" sortable="custom"></el-table-column>

            <el-table-column prop="buildnum" label="楼号" width="" align="center" sortable="custom"></el-table-column>

            <el-table-column prop="unitnum" label="单元号" width="" align="center" sortable="custom"></el-table-column>
            
            <el-table-column prop="doornum" label="门牌号" width="" align="center" sortable="custom"></el-table-column>

			<el-table-column prop="create_time" label="开户时间" width="" align="center" sortable="custom"></el-table-column>

			<el-table-column prop="" label="操作" width="260" align="center">
				<template scope="scope">
					<el-button type="primary" size="mini" @click="editInfo(scope.$index,scope.row)">修改业主信息</el-button>
					<el-button type="primary" size="mini" @click="resetCode(scope.$index,scope.row)">重置查询密码</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination @current-change="page=$event; getData()" :page-size="pageSize" layout="total,prev, pager, next" :total="total"></el-pagination>

        <UserInfoChange v-if="userInfoChangeShow" :loadData="rowData" :natures="natures" @onClose="onCloseUserInfo" />

    </div>

</template>

<script>
import UserInfoChange from '@/components/UserInfoChange'
export default {
    components: { UserInfoChange },

    props: [],

    data() {
        return{
            natures: [],

            select: {
                account: '',
                owner_name: '',
                owner_phone: '',
                nature: '',      
                buildnum: '',
                unitnum: '',
                doornum: '',          
            },

            dataset: [],
            page: 1,
            total: 0,
            pageSize: 15,
            prop: '',
            order: '',

            // 修改信息
            rowData: {},
            userInfoChangeShow: false,
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){
            this.$jssdk.member.getNature({},(res) =>{
                this.natures = res
            })
        },

        getData(item){
            let sort_by = '';
            let sort_to = '';
            if(item){
                sort_by = item.prop;
                sort_to = item.order;
            }
            this.$jssdk.account.list({
                page: this.page,
                sort_by: sort_by,
                sort_to: sort_to,
                account: this.select.account,
                owner_name: this.select.owner_name,
                owner_phone: this.select.owner_phone,
                nature: this.select.nature,
                buildnum: this.select.buildnum,
                unitnum: this.select.unitnum,
                doornum: this.select.doornum,
            }, (r) =>{
                this.dataset = r.meterList.data;
                this.total = r.meterList.total;
                for(var i = 0; i < r.meterList.data.length; i++) {
                    if(r.meterList.data[i].nature == '0') {
                        this.dataset[i].nature = '居民'
                    }
                    if(r.meterList.data[i].nature == '1') {
                        this.dataset[i].nature = '自营'
                    }
                    if(r.meterList.data[i].nature == '2') {
                        this.dataset[i].nature = '联营'
                    }
                    if(r.meterList.data[i].nature == '3') {
                        this.dataset[i].nature = '出租'
                    }
                    if(r.meterList.data[i].nature == '4'){
                        this.dataset[i].nature = '物业动力'
                    }
                    if(r.meterList.data[i].nature == '5'){
                        this.dataset[i].nature = '居民配套'
                    }
                    if(r.meterList.data[i].nature == '9') {
                        this.dataset[i].nature = '备用'
                    }
                }
            },(err) =>{
                this.$message({
                    type:'warning',
                    message:err.data,
                    duration:2000
                })
            });
        },

        // 重置
        resetting() {
            this.select.account = '';
            this.select.owner_name = '';
            this.select.owner_phone = '';
            this.select.nature = '';
            this.select.buildnum = '';
            this.select.unitnum = '';
            this.select.doornum = '';
        },

        // 导出
        downCode() {
            this.$jssdk.account.list({
                page: this.page,
                sort_by: this.prop,
                sort_to: this.order,
                account: this.select.account,
                owner_name: this.select.owner_name,
                owner_phone: this.select.owner_phone,
                nature: this.select.nature,
                buildnum: this.select.buildnum,
                unitnum: this.select.unitnum,
                doornum: this.select.doornum,
                is_export: '1',
            }, (r) =>{
                window.location.href = r.url
            },(err) =>{
                this.$message({
                    type:'warning',
                    message:err.data,
                    duration:2000
                })
            });
        },

        // 修改业主信息
        editInfo(index, row){
            this.rowData = row;
            this.userInfoChangeShow = true;
        },
        // 关闭业主信息
        onCloseUserInfo(){
            this.userInfoChangeShow = false;
            this.getData();
        },

        // 重置密码相关
        resetCode(index, row) {
            this.$confirm('确定重置查询密码？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(() => {
                this.$jssdk.account.resetPass({
                    account: row.account,
                }, (data) => {
                    this.$message({
                        type: 'success',
                        message: '重置表密码成功',
                        duration: 1000
                    })
                },(err) =>{
                    this.$message({
                        type: 'warning',
                        message: err.msg,
                        duration: 1000
                    })
                })
            });
        },
    },
}
</script>

<style lang='less'>

</style>

<style lang='less' scoped>
    
</style>


// WEBPACK FOOTER //
// UserSet.vue?2cfde070